/* eslint-disable no-case-declarations */
/* eslint-disable prefer-destructuring */

'use client';

import Link from 'next/link';
import type { ISbStoryData } from '@storyblok/react';
import { useMemo } from 'react';
import type { SB_MultilinkProps } from '../components/types.generated';
import { transformStoryblokLink } from '../components/utils';
import { cn } from '~/utils';

type ConditionalProps =
    | {
          type: 'story';
          link: ISbStoryData<unknown>;
      }
    | {
          type: 'link';
          link: SB_MultilinkProps;
      };

export const StoryblokLink: React.FC<
    Pick<React.ComponentProps<typeof Link>, 'children' | 'className' | 'target'> & ConditionalProps
> = props => {
    const conditionalProps = useMemo<{
        href: string;
        target?: React.HTMLAttributeAnchorTarget;
        children?: React.ReactNode;
    }>(() => {
        switch (props.type) {
            case 'story':
                return {
                    href: `/${props.link.full_slug}`,
                    target: '_self',
                    children: props.link.name,
                };
            case 'link':
                return transformStoryblokLink(props.link);

            default:
                throw new Error(`Unkown StoryblokLink type "${(props as any).type}"`);
        }
    }, [props.type, props.link]);

    return (
        <Link
            {...props} // Props need to be spread, because NavigationMenu.Link needs to pass `onClick` to close the menu
            className={cn('transition-colors hover:text-secondary', props.className)}
            href={conditionalProps.href}
            target={props.target || conditionalProps.target}
        >
            {props.children ?? conditionalProps.children}
        </Link>
    );
};
